/*
 * Automatically add the ADS .fancy-link class on all content text links
 */

export default function detectFancyLinks() {
  const linkEls = document.querySelectorAll("article p a, article li a");
  linkEls.forEach((linkEl) => {
    if (linkEl.hasAttribute("data-fancy-link-ignore")) return;
    linkEl.classList.add("fancy-link");
  });
}
